import { render, staticRenderFns } from "./message-room-default.vue?vue&type=template&id=0d08bce4&scoped=true"
import script from "./message-room-default.vue?vue&type=script&setup=true&lang=ts"
export * from "./message-room-default.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./message-room-default.vue?vue&type=style&index=0&id=0d08bce4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d08bce4",
  null
  
)

export default component.exports